import axiosInstance from "../../../../axiosInstance";
import history from "../../../../history";
import { success, error, info } from "../../../../store/notification/actions";
import { AIMS_RESET_PASSWORD_URL } from "../../../constants/baseConstants";

export async function SignUp(data) {
  if (data != null) {
    if (
      !data.firstName ||
      !data.lastName ||
      !data.email ||
      !data.mobileno ||
      !data.password ||
      !data.street1 ||
      !(data.selectedCountry && data.selectedCountry.id > 0) ||
      !(data.selectedState && data.selectedState.id > 0) ||
      !(data.selectedCity && data.selectedCity.id > 0) ||
      !data.zipcode
    ) {
      error("Please enter Required Field");
      return {
        message: "Please enter Required Field",
        hasError: true,
        data: "",
      };
    }
    info("Signing Up ...");
    return await axiosInstance
      .post("/user/signUp", {
        first_name: data.firstName,
        middlename: data.middleName ? data.middleName : "",
        last_name: data.lastName,
        user_emailid: data.email,
        mobileno: data.mobileno,
        password: data.password,
        street1: data.street1,
        street2: data.street2 ? data.street2 : "",
        country: data.selectedCountry.optionname,
        state: data.selectedState.optionname,
        city: data.selectedCity.optionname,
        zipcode: data.zipcode,
      })
      .then((response) => {
        if (response.data.status === "success") {
          history.push("/signIn");
          success("User account created successfully !!!");
          SendSignUpSuccessMail({
            user_name: response.data.data.messages,
            user_email: data.email,
            password: data.password,
          }).then((response) => {
            if (response) {
              history.push("/signIn");
              success("User account created successfully !!!");
              return { message: "", hasError: false, data: "" };
            } else {
              error("Email not sent !!!");
              return {
                message: "Email not sent !!!",
                hasError: true,
                data: "",
              };
            }
          });
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
  } else {
    return { message: "Internal error occurred", hasError: true, data: "" };
  }
}

export async function GetCountryDropDownData() {
  return await axiosInstance
    .get("/common/GetCountries")
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data.map((obj) => ({
          id: obj.country_id,
          optionname: obj.country_name,
        }));
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function GetStateDropDownData(params) {
  return await axiosInstance
    .get("/common/GetStates", {
      params: params,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data.map((obj) => ({
          id: obj.state_id,
          optionname: obj.state_name,
        }));
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function GetCityDropDownData(params) {
  return await axiosInstance
    .get("/common/GetCities", {
      params: params,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data.map((obj) => ({
          id: obj.city_id,
          optionname: obj.city_name,
        }));
      } else {
        return [];
      }
    })
    .catch((err) => {});
}

export async function SendSignUpSuccessMail(params) {
  try {
    const response = await axiosInstance.post("/email/sendemail", {
      user_email: params.user_email,
      user_name: params.user_name,
      password: params.password,
      email_content: `\n Welcome to AIMS. \n Login with \n UserName: ${params.user_name} \n Password: ${params.password} \n to explore the application. \n ${AIMS_RESET_PASSWORD_URL}`,
    });
    if (response) {
      return true;
    } else {
      return false;
    }
  } catch (err) {}
}

export async function GetZipDetails(params) {
  info("Fetching country, state & city mapping ...");
  return await axiosInstance
    .get("/common/getZipDetails", {
      params: params,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (!response.data.data.length) {
          error("No mapping found for the zip code.");
        } else {
          success("Country, state & city mapped successfully !!!");
        }
        return response.data.data;
      } else {
        return [];
      }
    })
    .catch((err) => {});
}
